import { useState, useEffect, useCallback, useRef } from 'react'
import { notificacionesAPI } from '../services/api'

export const useNotificaciones = (empleado) => {
  const [count, setCount] = useState(0)
  const [notificaciones, setNotificaciones] = useState([])
  const [loading, setLoading] = useState(false)
  const intervalRef = useRef(null)

  // Fetch unread count (ligero - solo COUNT(*))
  const fetchCount = useCallback(async () => {
    if (!empleado || empleado.rol === 'super_admin') return
    try {
      const res = await notificacionesAPI.getNoLeidasCount()
      setCount(res.data.count)
    } catch (err) {
      console.error('Error fetching notification count:', err)
    }
  }, [empleado])

  // Recargar count (usado externamente tras verificación)
  const verificar = useCallback(async () => {
    if (!empleado || empleado.rol === 'super_admin') return
    await fetchCount()
  }, [empleado, fetchCount])

  // Cargar lista completa (al abrir dropdown)
  const fetchNotificaciones = useCallback(async () => {
    if (!empleado || empleado.rol === 'super_admin') return
    setLoading(true)
    try {
      const res = await notificacionesAPI.getAll()
      setNotificaciones(res.data)
    } catch (err) {
      console.error('Error fetching notifications:', err)
    } finally {
      setLoading(false)
    }
  }, [empleado])

  // Marcar una como leída
  const marcarLeida = useCallback(async (id) => {
    try {
      await notificacionesAPI.marcarLeida(id)
      setNotificaciones(prev => prev.map(n => n.id === id ? { ...n, leida: 1 } : n))
      setCount(prev => Math.max(0, prev - 1))
    } catch (err) {
      console.error('Error marking notification as read:', err)
    }
  }, [])

  // Marcar todas como leídas
  const marcarTodasLeidas = useCallback(async () => {
    try {
      await notificacionesAPI.marcarTodasLeidas()
      setNotificaciones(prev => prev.map(n => ({ ...n, leida: 1 })))
      setCount(0)
    } catch (err) {
      console.error('Error marking all as read:', err)
    }
  }, [])

  // Inicialización + polling
  useEffect(() => {
    if (!empleado || empleado.rol === 'super_admin') return

    verificar()
    fetchCount()

    // Poll count cada 60 segundos
    intervalRef.current = setInterval(fetchCount, 60000)

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current)
    }
  }, [empleado, verificar, fetchCount])

  return {
    count,
    notificaciones,
    loading,
    fetchNotificaciones,
    marcarLeida,
    marcarTodasLeidas,
    recargar: fetchCount
  }
}
